<template>
  <v-container>
    <v-form ref="form" v-model="valid">
      <v-select
        :label="$t('entities.environment.calendarProd.props.dayOfWeek')"
        v-model="value.dayOfWeek"
        :items="dayOfWeeks"
        item-text="value"
        item-value="key"
        required
        :rules="$isRequiredRule"
      ></v-select>

      <timePicker
        ref="timeStart"
        v-model="value.start"
        :label="$t('entities.environment.calendarProd.props.start')"
        hour-format="24"
        :required="true"
      ></timePicker>
      <timePicker
        ref="timeEnd"
        v-model="value.end"
        :label="$t('entities.environment.calendarProd.props.end')"
        hour-format="24"
        :required="true"
      ></timePicker>
    </v-form>
  </v-container>
</template>
<script>
//import moment from "moment";
import timePicker from "@/components/pickers/timePicker";
export default {
  components: { timePicker },
  props: {
    value: {}
  },
  watch: {
    value() {
      this.$refs.form.resetValidation();
    }
  },
  data() {
    return {
      valid: true,

      dayOfWeeks: [
        { key: 0, value: this.$t("dayOfWeek.sunday") },
        { key: 1, value: this.$t("dayOfWeek.monday") },
        { key: 2, value: this.$t("dayOfWeek.tuesday")  },
        { key: 3, value: this.$t("dayOfWeek.wednesday")  },
        { key: 4, value: this.$t("dayOfWeek.thursday")  },
        { key: 5, value: this.$t("dayOfWeek.friday")  },
        { key: 6, value: this.$t("dayOfWeek.saturday")  }
      ]
    };
  },
  methods: {
    isValid() {
      let timeStartIsValid = this.$refs.timeStart.isValid();
     let timeEndIsValid = this.$refs.timeEnd.isValid();
     let formIsValid = this.$refs.form.validate() ;
      let res =
        (timeStartIsValid && timeEndIsValid && formIsValid);
      return res;
    }
  }
};
</script>

